<script lang="ts">
	import Error from '$lib/UI/Error.svelte';
</script>

<Error />
